export default "__VITE_ASSET__CWZMGhaz__"